<template>
  <div>
    <!-- 所有一览按钮 -->
    <el-button class="btn-default glance-narrow-down my-button" size="small" @click="onClick" :disabled="disabled">
      <slot></slot>
    </el-button>
  </div>
</template>
<script>
export default {
  props:{
    disabled:Boolean
  },
  methods: {
    onClick(event) {
      if (this.$listeners.click) {
        this.$listeners.click()
        event.stopPropagation();
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.glance-narrow-down {
  width: 292px;
  height: 40px;
  line-height: 18px;
  text-align: center;
  padding: 0;
  color:#525250;
  font-size: 13px;
  background-color: #F2F2ED;
  border: 0;
  box-shadow: -2px -2px 4px #fff,
              4px 4px 4px #E6E6E1;
}

.my-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  color:#525250;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 10px 20px;
  font-size: 13px;
  border-radius: 8px;
  width: 292px;
  height: 40px;
  background-color: #F2F2ED;
  border: 0;
  box-shadow: -2px -2px 4px #fff,
              4px 4px 4px #E6E6E1;
  &:focus,
  &:hover {
      background: #F2F2ED;
      color: #525250;
      border-radius: 8px;
  }
  &.is-disabled {
      color: #B8B8B4;
      background-color: #F2F2ED;
  }
  &.is-plain:hover {
    background: #fff;
    border-color: #409eff;
    color: #409eff;
    &.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
      background-image: none;
      background-color: #fff;
      border-color: #ebeef5;
    }
  }
  & + .my-button {
    margin-left: 20px;
  }
}
</style>
